The response from the `updateWebhookSubscriptionDeliveryConfiguration` mutation.
